module.exports = __webpack_public_path__ + "img/09.69d516fb.jpg";